const TIME = /^([01]\d|2[0-3]):[0-5]\d$/;
const DATE = /^\d{4}-\d{2}-\d{2}$/;
export const isExplicitDateTime = (date, time) => DATE.test(date || "") && TIME.test(time || "");
export function normalizeNearbySlots(value) {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const result = [];
  for (const entry of value) {
    if (!entry || !TIME.test(entry.slotStart || "") || !TIME.test(entry.slotEnd || "")) return [];
    if (!seen.has(entry.slotStart)) {
      seen.add(entry.slotStart);
      result.push({ slotStart: entry.slotStart, slotEnd: entry.slotEnd });
    }
  }
  return result.slice(0, 4);
}
export function validatePartySize(value, max = 20) {
  const number = Number(value);
  const valid = value !== "" && Number.isInteger(number) && number >= 1 && number <= Number(max || 20);
  return valid ? { valid, value: number } : { valid: false, value: number };
}
const priceLabel = (bar, zone) => {
  if (bar?.reservationMode !== "deposit") return "Sin seña";
  const amount = bar?.zonePricingEnabled && zone.priceEnabled && Number(zone.price) > 0
    ? Number(zone.price) : Number(bar?.depositAmount);
  return amount > 0 ? `$${amount.toLocaleString("es-AR")}` : "Sin seña";
};
export function deriveFittingZones(availability, selectedSlot, partySize, bar) {
  if (!Array.isArray(availability?.zones) || !selectedSlot || !Number.isInteger(partySize)) return [];
  return availability.zones.flatMap((zone) => {
    const slot = Array.isArray(zone?.slots) && zone.slots.find((item) =>
      item?.slotStart === selectedSlot.slotStart &&
      (!selectedSlot.slotEnd || !item.slotEnd || item.slotEnd === selectedSlot.slotEnd));
    return slot?.available === true && Number.isInteger(slot.availableCount) && slot.availableCount >= partySize
      ? [{ name: zone.name, priceLabel: priceLabel(bar, zone) }] : [];
  });
}
export function normalizeAvailability(response) {
  const info = response?.data?.info;
  return info && Array.isArray(info.zones) ? info : null;
}
export async function runLatestRequest(owner, request, context, handlers) {
  const id = ++owner.current;
  handlers.start?.(context);
  try {
    const value = await request();
    if (id === owner.current) handlers.success?.(value, context);
  } catch (error) {
    if (id === owner.current) handlers.error?.(error, context);
  } finally {
    if (id === owner.current) handlers.finish?.(undefined, context);
  }
}
